module.exports = __webpack_public_path__ + "static/media/como-funciona-ico-4-sel.453372f7.svg";